import React from 'react';
import { useTranslation } from 'react-i18next';
import { CookieBanner, cookieBannerLabels, cookiePolicyUrl } from '@easydent/shared-ui';

/**
 * The shared cookie banner, in the language the rest of the portal is using.
 *
 * `useSuspense: false` for the same reason as the other apps: translations load over HTTP and the
 * banner renders outside any Suspense boundary, so a suspending hook would throw rather than wait.
 * An early render falls back to the English defaults and re-renders when the namespace arrives.
 *
 * The policy link points at the public site — this portal has no legal-documents route of its own,
 * and a consent banner whose policy link 404s is worse than no link at all.
 */
const AppCookieBanner: React.FC = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  return <CookieBanner labels={cookieBannerLabels(t)} cookiePolicyHref={cookiePolicyUrl()} />;
};

export default AppCookieBanner;
